<template>
  <p>
    <span>
      {{ paymentMonths }} payments of
      <b>{{ $filters.toCurrency(monthlyPayment, price.currencyCode) }}</b> with
    </span>
    <img src="@/assets/images/payment-methods/clearpay.svg" width="78" />
  </p>
</template>

<script>
export default {
  name: "Clearpay",
  props: {
    price: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      paymentMonths: 4,
    };
  },
  computed: {
    monthlyPayment() {
      return this.price.amount / this.paymentMonths;
    },
  },
};
</script>
